import React, { useState, useEffect } from "react";
import "./pages.css";
import { useParams, useNavigate } from "react-router-dom";
import axiosConfig from "../config.js";
import { DeleteButton } from "../components/DialogueBox.jsx";
import  EditingButton  from "../components/forms/EditingButton.jsx";
import PatientBiographicals from "../components/details/PatientBiographicals.jsx";
import OtherTable from "../components/details/OtherTable.jsx";

import { CircleX, SaveOff, Save, Pencil } from "lucide-react";
import BooleanDisplay, {True, False} from "../components/misc/BooleanDisplay.jsx";
import { useAuth } from "../contexts/AuthContext.jsx";

const OperationDetails = () => {

  const { operationId } = useParams();
  const [isOperationFormVisible, setIsOperationFormVisible] = useState(false);
  const [operationDetails, setOperationDetails] = useState(null);
  const [patientDetails, setPatientDetails] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editedOperation, setEditedOperation] = useState({})
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [updateDialogPayload, setUpdateDialogPayload] = useState(null);

  const { user } = useAuth();

  
  const openOperationForm = () => {
    setIsOperationFormVisible(true);
  };

  const closeOperationForm = () => {
    setIsOperationFormVisible(false);
  };

  const handleUpdateDialogClose = () => {
    setUpdateDialogOpen(false);
    setUpdateDialogPayload(null);
  };
  

  // Axios call for the single patient operation. 
  const fetchDetails = async () => {
      try {
        const operationData = await axiosConfig.get(`/operation/${operationId}`);
        const operation = operationData.data.operation || {};
        setOperationDetails(operation); 

        const patientData = await axiosConfig.get(`/patient/${operation.chId}`); 
        setPatientDetails(patientData.data.patient || {}); 
      } catch (error) {
        console.error("Error fetching details:", error);
      }
    };

  useEffect(() => {
    if (operationId) {
      fetchDetails();
    }
  }, [operationId, fetchDetails]);

  useEffect(() => {
    if (operationDetails) {
    }
  }, [operationDetails]);
  if (!patientDetails || !operationDetails
  ) {
    return <div> Loading... </div>;
  }
  
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditedOperation((prev) => ({
      ...(prev ?? null),
      [name]: value,
    }));
  };
  
  

  if (!patientDetails || !operationDetails
  ) {
    return <div> Loading... </div>;
  }

  // these are TEMP. when the backend returns only strings to the frontend, these maps can be removed
  // nah i'd enums.js

  // const mapOperation = {
  //   0: "Hip Replacement",
  //   1: "Knee Replacement",
  // };


  // const mapSurgerySide = {
  //   "L": "Left",
  //   "R": "Right",
  // };

  //  // again, these are TEMP. when the backend returns only strings to the frontend, these maps can be removed
  // const operationLabel = ValueMappings.operationType[operationDetails.operationType] || "N/A";

  // const surgerySideLabel = ValueMappings.surgerySide[operationDetails.surgerySide];
 
  
  const handleUpdateOperation = async (operationId) => {
    const userEmail = prompt("To confirm the update, please enter your email:");


    // If there is nothing, then 
    if (!userEmail) {
      alert("Please provide an email address.")
      // setUpdateDialogPayload({ error: "Please enter an email address." });
      // setUpdateDialogOpen(true);
      return;
    } else if (userEmail.trim() !== user.email ) {
      alert("Incorrect email address provided.");
      // setUpdateDialogPayload({ error: "Incorrect email address." });
      // setUpdateDialogOpen(true);
      return;
    }

    // If the user email doesn't match, then put this error message. If !userEmail = userAgent or something 
    // alert("You must rewrite yoru email correctly or some bs")

  
    try {
      setIsUpdating(true);

      const allowedFields = [
        // "_id",
        "surgerySide",
        "operationType",
        "painLevel",
        "radioSeverity",
        "adl",
        "mobility",
        "surgeonId",
        "ntcSuitability",
        "ntcAttendance",
        "theatreDate",
        "roboticSurgery",
        "bedRequired",
        "preassessmentPassed",
        "workOrCareImpairment",
        "mentalHealthImpairment",
      ];

      const sanitisedOperation = allowedFields.reduce((acc, key) => {
        if (editedOperation.hasOwnProperty(key)) {
          acc[key] = editedOperation[key];
        }
        return acc;
      }, {});

      const response = await axiosConfig.patch(`/operations/${operationId}`, sanitisedOperation);

    
      console.log("Operation updated successfully:", response.data);
      setIsEditing(false);
      // trigger update
      await fetchDetails();
      // vv this doesnt work
      // setOperationDetails(response.data.updatedOperation || editedOperation);


    } catch (error) {
      const message = error.response?.data?.message || error.message || "Unknown error";
      setUpdateDialogPayload({ error: message });
      setUpdateDialogOpen(true);
    } finally {
      setIsUpdating(false);
    }
  };
  



  return (
    <>
      <div className="dashboard-container">
        <PatientBiographicals patientDetails={patientDetails} />
      </div>

      <div className="dashboard-container">
        <div className="details-page">
          <div className="patient-table-section">
              <table className="patient-table-details">
                <thead>
                  <tr>
                    <th> Surgeon ID </th>
                    <th> Operation Type </th>
                    <th> Surgery Side </th>
                    <th> Preassessment Status </th>
                    <th> Provisional Theatre Date </th>
                    <th> HDU/ITU Bed Requirement </th>
                    <th> NTC Suitability </th>
                    <th> Robotic Surgery </th>
                    <th> Priority Score </th>
                  </tr>
                </thead>
                <tbody>
                  <EditingButton 
                    operationDetails={operationDetails}
                    editedOperation={editedOperation}
                    handleEditChange={handleEditChange}
                    isEditing={isEditing}
                  />
                </tbody>
              </table>
            </div>
          </div>


        {/** When the editing button (above) is selected, makes the fields in the table
         * changeable. These changes are saved (or cancelled) depending on the user's choice. 
         */}
        <div className="patient-table-section">
          <OtherTable
            patientDetails={patientDetails}
            operationDetails={operationDetails}
            isEditing={isEditing}
            editedOperation={editedOperation}
            handleEditChange={handleEditChange}/>
        </div>
      </div>

      {/** Buttons for admins to use. Default is editing, and deletion. 
       * With deletion, you can delete the operation (after confirming email) or cancelling it.
       * With editing, another button opens: the cancel button *for* editing, which stops the table lines from being
       * editable, and makes it go back to default. 
       */}
      <div className="admin-button-container">

      <button
        className={`edit-button action-button ${isUpdating ? "loading" : ""}`}
        onClick={() => {
          if (isEditing) {
            handleUpdateOperation(operationId);
          } else {
            setIsEditing(true);
          }
        }}
        disabled={isUpdating}
      >
        <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between", gap: 6}}>      
          {isUpdating ? <SaveOff size={16} /> : isEditing ? <Save size={16} /> : <Pencil size={16}/>}
          {isUpdating ? "Saving..." : isEditing ? "Save" : "Edit"}
        </div>
      </button>

      {isEditing && (
        <button
          className="cancel-button action-button"
          onClick={() => {
            setIsEditing(false);
            setEditedOperation({}); // reset edits
          }}
        >
          <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between", gap: 6}}>
            <CircleX size={12} /> Cancel
          </div>
        </button>
      )}

        <DeleteButton />
        
      </div>
    </>
  );
};


export default OperationDetails;
